import AppModule from "@/app/modules/module";

export default new AppModule("index")
  .routers([
    {
      path: "/index",
      component: AppModule.layout.DefaultLayout,
      // beforeEnter: Guards([authManager]),
      children: [
        {
          path: "/",
          component: () => import("./views/index"),
          meta: {
            title: "Backstage │ 日本最大級のエンタメ特化のマッチングプラットフォーム",
            bodyClass: "body-home",
          },
        },
      ],
    },
    {
      path: "/search/public/worker",
      component: AppModule.layout.DefaultLayout,
      children: [
        {
          path: "/",
          component: () => import("./views/search-public-worker"),
        },
      ],
    },
    {
      path: "/search/public/project",
      component: AppModule.layout.DefaultWorkerLayout,
      children: [
        {
          path: "/",
          component: () => import("./views/search-public-project"),
        },
      ],
    },
    {
      path: "/worker/detail/:id",
      component: AppModule.layout.DefaultLayout,
      children: [
        {
          path: "/",
          name: "master.worker.detail",
          component: () => import("./views/master-detail-worker"),
        },
      ],
    },
    {
      path: "/project/detail/:id",
      component: AppModule.layout.DefaultLayout,
      children: [
        {
          path: "/",
          name: "master.project.detail",
          component: () => import("./views/master-detail-project"),
        },
      ],
    },
    {
      path: "/terms-of-use",
      component: AppModule.layout.DefaultLayout,
      children: [
        {
          path: "/",
          name: "terms.of.service",
          component: () => import("../company/c-auth/views/terms-of-use"),
        },
      ],
    },
    {
      path: "/privacy-policy",
      component: AppModule.layout.DefaultLayout,
      children: [
        {
          path: "/",
          name: "privacy.policy",
          component: () => import("../company/c-auth/views/privacy-policy"),
        },
      ],
    },
  ])
  .register();
